import React, {useState, useEffect} from 'react';
import {Select, Form} from 'antd';
import api from '../../server/api'
import './index.scss';


const UserManagement = props => {
    const [options, setOptions] = useState([]);
    // const [parameter, setParameter] = useState({})
    useEffect(() => { // 获会员列表
        api.memberList({page: 1, page_size: 1000000}).then(res => {
            const options = [];
            res.list.forEach(item => {
                options.push({
                    label: item.level_name,
                    value: item.level_id,
                })
            })
            setOptions(options);
        })
    },[props])
  
    return (
        <Form.Item
            label={props.label}
            name={props.name}
            rules={props.rules}
        >
            <Select
                allowClear
                optionFilterProp="children"
                placeholder={props.placeholder}
                options={options} 
            />
        </Form.Item>
        
    )
}

export default UserManagement;